import React from 'react';

const Footer = ({ onOpenLogin }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <span className="footer-copyright">
          © {currentYear} Gestas ML - Todos los derechos reservados
        </span>
        
        <button onClick={onOpenLogin} className="footer-cta-button">
          Crear mi primera predicción
        </button>

        <div className="footer-links">
          <span>Política de privacidad</span>
          <span>Términos y condiciones</span>
          <span>Contacto</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;